import {
  Activity,
  AlertCircle,
  Apple,
  Calendar,
  ClipboardList,
  Droplets,
  FileBarChart,
  FileImage,
  FileText,
  Heart,
  Layers,
  MessageSquare,
  Pill,
  Plus,
  PlusCircle,
  Radio,
  Ruler,
  Scale,
  Settings,
  Stethoscope,
  Thermometer,
  Users,
  UserCog,
  Utensils,
  Wind,
  type LucideIcon,
} from "lucide-react";
import type { SiteIconKey } from "@/design-system/tokens/iconography";

export const siteIconRegistry: Record<SiteIconKey, LucideIcon> = {
  activity: Activity,
  alertCircle: AlertCircle,
  apple: Apple,
  calendar: Calendar,
  clipboardList: ClipboardList,
  droplets: Droplets,
  fileBarChart: FileBarChart,
  fileImage: FileImage,
  fileText: FileText,
  heart: Heart,
  layers: Layers,
  messageSquare: MessageSquare,
  pill: Pill,
  plus: Plus,
  plusCircle: PlusCircle,
  radio: Radio,
  ruler: Ruler,
  scale: Scale,
  settings: Settings,
  stethoscope: Stethoscope,
  thermometer: Thermometer,
  users: Users,
  userCog: UserCog,
  utensils: Utensils,
  wind: Wind,
};

export const getSiteIcon = (name: SiteIconKey) => siteIconRegistry[name];
